import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  getCampaignDisplayStatus,
  type CampaignDisplayStatus
} from '@/ducks/campaigns/campaigns.helpers'
import type { Campaign } from '@/ducks/campaigns/campaigns.types'

import Styles from './CampaignsTable.module.scss'

type Props = {
  campaign: Campaign
}

const statusClassMap: Record<CampaignDisplayStatus, string> = {
  active: Styles.statusActive,
  inactive: Styles.statusInactive,
  expired: Styles.statusExpired
}

const CampaignStatusCell = ({ campaign }: Props) => {
  const { t } = useTranslation()
  const displayStatus = getCampaignDisplayStatus(campaign)

  return (
    <span
      className={`${Styles.statusTag} ${statusClassMap[displayStatus]}`}>
      {t(`marketing.campaigns.status.${displayStatus}`)}
    </span>
  )
}

export default CampaignStatusCell
